module.exports = __webpack_public_path__ + "img/W-S12.a03d50de.jpg";